export enum TextMessageType {
  SMS = "sms",
  MMS = "mms",
}
